import { useEffect, useContext } from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import AOS from 'aos'
import access from 'src/utils/localAccess'
import 'aos/dist/aos.css'
import modules from 'src/app/app-module'
import dashboardModules from 'src/app/dashboard/dashboard-module'
import dashboardV2Modules from 'src/app/dashboardv2/dashboard-module'
import AppDesign from 'src/app/dashboard/appDesign'
import { PopUps } from 'src/component'
import DashboardIndexRedirect from 'src/app/dashboardv2/DashboardIndexRedirect'

export const AppRoutes = () => {

    const {notifier, isConnected} = useContext(VisibilityContext)
    const {recoverStatesData} = useContext(AppInfoContext)

    useEffect(() => {
        AOS.init({
            duration: 300,
            delay: 20,
            easing: 'linear'
        })
    }, [])

    useEffect(() => {
        let isOnline = window.navigator.onLine
        access.setInternetStatus(isOnline)
        isConnected(isOnline)
        recoverStatesData()
    }, [])

    useEffect(() => {
        window.addEventListener("offline",
            () => handleInternetConnection(false)
        );
        window.addEventListener("online",
            () => handleInternetConnection(true)
        );

        return () => {
            window.removeEventListener("offline", () => handleInternetConnection(false)
            );
            window.removeEventListener("online", () => handleInternetConnection(true));
        };
    }, [])

    function handleInternetConnection (isOnline: boolean) {
        if(!isOnline)  notifier.show('Oops...You are offline', '')
        else notifier.show('Network has been restored', '', 'success')
        access.setInternetStatus(isOnline)
        isConnected(isOnline)
    }
    return (
        <>
            <PopUps />
            <Router>
                <Routes>
                    {
                        modules.map(module => (
                            module.name === 'Dashboard' ?
                                <Route {...module.routeProps} key={module.name} >
                                    {
                                        dashboardModules.map(dashboardModule => (
                                            <Route {...dashboardModule.routeProps} key={dashboardModule.name}  />
                                        ))
                                    }
                                    <Route index element={AppDesign.routeProps.element} />
                                </Route>
                                : module.name === 'DashboardV2' ?
                                    <Route {...module.routeProps} key={module.name} >
                                        {
                                            dashboardV2Modules.map(dashboardV2Module => (
                                                <Route {...dashboardV2Module.routeProps} key={dashboardV2Module.name} />
                                            ))
                                        }
                                        <Route index element={<DashboardIndexRedirect />} />
                                    </Route>
                                    :
                                    <Route {...module.routeProps} key={module.name}  />
                        ))
                    }
                    <Route path="*" element={<Navigate to="/" />}/>
                </Routes>
            </Router>
        </>
    )
}